import { Button, Divider, Input } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { IAudience } from '../../../models';
import { IImportRetryModel } from '../../../models/IImportRetryModel';
import { CardLayout, Col3Col9, LabelAbove, Section } from '../../common';

export interface IImportRetryProps {
	surveyId: number;
	audiences: IAudience[];
	isSendingRequest: boolean;
	importRetryModel: IImportRetryModel;
	RestartDatasetImport: (surveyId: number, mSuiteDatasetId: number) => void;
	HandlemSuiteClientGuidChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
	HandlemSuiteDatasetIdChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
	HandlemResearchEvtAssgIdChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
}

export class ImportRetry extends React.PureComponent<IImportRetryProps> {
	constructor(props: IImportRetryProps) {
		super(props);
	}

	public render() {
		const { importRetryModel, surveyId } = this.props;

		return (
			<CardLayout loading={false} title={ContentConstants.SURVEY_ADMIN_ACTION_IMPORT_RETRY}>
				<Section id='survey-name' sectionHeader='Import Retry'>
					<Col3Col9 label='mSuite Dataset Id'>
						<LabelAbove type='input'>DatasetId from mSuite</LabelAbove>
						<Input
							value={importRetryModel.mSuiteDatasetId.toString()}
							onChange={this.props.HandlemSuiteDatasetIdChange}
							id='survey-name'
							maxLength={150}
						/>
					</Col3Col9>
					<Divider type='dashed' />
				</Section>
				<Divider type='dashed' />
				<Button
					id='SaveAndNextStepButton'
					color='primary'
					size='lg'
					onClick={() => this.props.RestartDatasetImport(surveyId, this.props.importRetryModel.mSuiteDatasetId)}
					disabled={this.props.isSendingRequest}
				>
					{ContentConstants.BUTTONS_CONTINUE}
				</Button>
			</CardLayout>
		);
	}
}
